import * as PIXI from 'pixi.js';
import type { BaseSettings } from './TimeAwareBase';
import { TimeInvariantBase } from './TimeInvariantBase';
import { getAttributesToSerialize, NumberAttribute } from './attributes';

/**
 * Specifies the position for the Transformation of an Asset
 */
class Position extends TimeInvariantBase {
    override _classType = 'Position';
    @NumberAttribute()
    accessor x = 0;
    @NumberAttribute()
    accessor y = 0;

    constructor(settings: Partial<BaseSettings>) {
        super(settings as BaseSettings);
    }

    override get readonlyProperties() {
        return [];
    }

    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    }

    override get editableProperties() {
        return getAttributesToSerialize(this);
    }
}

/**
 * Specifies the anchor for the Transformation of an Asset.
 */
class Anchor extends TimeInvariantBase {
    override _classType = 'Anchor';
    @NumberAttribute()
    accessor x = 0;
    @NumberAttribute()
    accessor y = 0;

    constructor(settings: Partial<BaseSettings>) {
        super(settings as BaseSettings);
    }

    override get readonlyProperties() {
        return [];
    }

    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    }
}

/**
 * Specifies the Transformation for an Asset which is composed out of a position, rotation and anchor.
 */
export class Transformation extends TimeInvariantBase {
    override _classType = 'Transformation';
    @NumberAttribute()
    accessor rotation = 0;
    position = new Position({ parent: this, updateParentOnUpdate: true });
    anchor = new Anchor({ parent: this, updateParentOnUpdate: true });

    constructor(settings: Partial<BaseSettings>) {
        super(settings as BaseSettings);
    }

    override get readonlyProperties() {
        return [];
    }

    override get propertiesToSerialize() {
        return ['position', 'anchor'].concat(getAttributesToSerialize(this));
    }

    override get editableProperties() {
        return super.editableProperties.concat(['position']);
    }

    get angle() {
        return this.rotation * PIXI.RAD_TO_DEG;
    }

    /**
     * Specifies the rotation in degrees instead of radians
     */
    set angle(value) {
        this.rotation = value * PIXI.DEG_TO_RAD;
    }
}
